import {fetch} from 'whatwg-fetch';
import UserTokenService from '../../../assets/editor/js/services/UserTokenService';
import {AppError} from '@assets/core/AppError';

class FilemanagerService {

    constructor() {
        this.userTokenService = new UserTokenService();
        this.refreshTokenAttempts = 0;

        const filemanagerDomain = $('[name=vikon_filemanager_domain]').get();
        this.domain = $(filemanagerDomain).length > 0 ? $(filemanagerDomain).val() : '';
    }

    async refreshToken() {
        if (this.refreshTokenAttempts > 3) {
            throw new AppError('Превышено количество попыток обновления токена');
        }
        await this.userTokenService.clearToken();
        this.refreshTokenAttempts += 1;
    }

    getDomain() {
        return this.domain;
    }

    async generateArchiveByField({fieldName, rowId, tableId}) {
        const url = `${this.domain}files/generateArchiveByField`;
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            body: JSON.stringify({
                table_id: tableId,
                row_id: rowId,
                field_name: fieldName,
                token,
            }),
        };
        const response = await fetch(url, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.generateArchiveByField({fieldName, rowId, tableId});
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Ошибка при генерации архива, возможно, отсутствуют файлы.');
        }
    }

    async downloadArchive(fileName) {
        const token = await this.userTokenService.getToken();
        const link = document.createElement('a');
        link.href = `${this.domain}file/archive/${fileName}?token=${token}`;
        document.body.appendChild(link);
        link.download = fileName;
        link.click();
        document.body.removeChild(link);
    }

    async getSettings() {
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };
        const token = await this.userTokenService.getToken();
        const response = await fetch(`${this.domain}settings?token=${token}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.getSettings();
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить настройки', 500);
        }
    }

    async saveSettings(settings) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({...settings, token}),
        };
        const response = await fetch(`${this.domain}settings`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.saveSettings(settings);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось сохранить настройки', 500);
        }
    }

    async getWorkPackageOfSignatures() {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };
        const response = await fetch(`${this.domain}settings/getWorkPackageOfSignatures?token=${token}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.getWorkPackageOfSignatures();
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить информацию для работы с цифровыми подписями', 500);
        }
    }

    async getSignatures() {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };
        const response = await fetch(`${this.domain}settings/signatures?token=${token}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.getSignatures();
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить цифровые подписи', 500);
        }
    }

    async getSignature(id) {
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };
        const token = await this.userTokenService.getToken();
        const response = await fetch(`${this.domain}settings/signatures/${id}?token=${token}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.getSignature(id);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить цифровую подпись', 500);
        }
    }

    async createSignature(signature) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...signature,
                token,
            }),
        };
        const response = await fetch(`${this.domain}settings/signatures`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.createSignature(signature);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Ошибка при создании цифровой подписи', 500);
        }
    }

    async updateSignature(id, signature) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...signature,
                token,
            }),
        };
        const response = await fetch(`${this.domain}settings/signatures/${id}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.updateSignature(id, signature);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось сохранить цифровую подпись', 500);
        }
    }

    async deleteSignature(ids) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ids,
                token,
            }),
        };
        const response = await fetch(`${this.domain}settings/signatures`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.deleteSignature(ids);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось удалить цифровые подписи', 500);
        }
    }

    async replaceSignature(signatureEditId, signatureReplaceId) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                edit_id: signatureEditId,
                replace_id: signatureReplaceId,
                token,
            }),
        };
        const response = await fetch(`${this.domain}settings/replaceSignature`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.replaceSignature(signatureEditId, signatureReplaceId);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось заменить цифровую подпись', 500);
        }
    }

    async bindSignature(id, bindOptions) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                token,
                ...bindOptions,
            }),
        };
        const response = await fetch(`${this.domain}files/bindSignature/${id}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.bindSignature(id);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось массово подписать файлы', 500);
        }
    }

    async getAllFilesForFileEditor(page, perPage, fileTitle, fileName, fileMissing) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };
        const response = await fetch(
            `${this.domain}files/allFiles?token=${token}&page=${page}&perPage=${perPage}&fileTitle=${fileTitle}
            &fileName=${fileName}&fileMissing=${fileMissing}`,
            options,
        );
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.getAllFilesForFileEditor(page, perPage, fileTitle, fileName, fileMissing);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить список файлов', 500);
        }
    }

    async saveFileEditor(data) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...data,
                token,
            }),
        };
        const response = await fetch(`${this.domain}files/fileEditorSave`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.saveFileEditor(data);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось сохранить изменения', 500);
        }
    }

    async deleteFileEditor(data) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...data,
                token,
            }),
        };
        const response = await fetch(`${this.domain}files/fileEditorDelete`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.saveFileEditor(data);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось удалить файл', 500);
        }
    }

    async getFilesOnEditorPage(sprTableId, rowId) {
        try {
            const token = await this.userTokenService.getToken();
            const options = {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                },
            };

            const response = await fetch(
                `${this.domain}files/getFilesOnEditorPage?token=${token}&sprTableId=${sprTableId}&rowId=${rowId}`,
                options,
            );
            if (response.ok) {
                return response.json();
            }
            switch (response.status) {
                case 401:
                    await this.refreshToken();
                    return this.getFilesOnEditorPage(sprTableId, rowId);
                case 422:
                    throw new AppError((await response.json()).messages.join('<br>'));
                default:
                    throw new AppError('Не удалось получить файлы', 500);
            }
        } catch (e) {
            console.log(e);
            throw e;
        }
    }

    async saveFiles(data) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...data,
                token,
            }),
        };
        const response = await fetch(`${this.domain}files/save`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.saveFiles(data);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось сохранить файлы', 500);
        }
    }

    async recoveryFiles(data) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...data,
                token,
            }),
        };
        const response = await fetch(`${this.domain}files/recovery`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.recoveryFiles(data);
            case 403:
                throw new AppError(`Не удалось восстановить файл. ${(await response.json()).error}`);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось восстановить файлы', 500);
        }
    }

    async generateApplicantArchive(data) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...data,
                token,
            }),
        };
        const response = await fetch(`${this.domain}api/admission_committees/applicants/zajavl/files`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.generateApplicantArchive(data);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось сгенерировать архив файлов', 500);
        }
    }

    async checkExistArchiveFilesForUpdate() {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };
        const response = await fetch(`${this.domain}file/savedArchive/isExist?token=${token}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.checkExistArchiveFilesForUpdate();
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось проверить наличие архивов с файлами для обновления', 500);
        }
    }

    async checkExistArchiveFilesForIntervalDate() {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };
        const response = await fetch(`${this.domain}file/archivesIntervalDate/isExist?token=${token}`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.checkExistArchiveFilesForIntervalDate();
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось проверить наличие архивов с файлами', 500);
        }
    }

    async getFilesInfoDate(data) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...data,
                token,
            }),
        };
        const response = await fetch(`${this.domain}files/getFilesInfoDate`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.getFilesInfoDate(data);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError(
                    'Не удалось получить информацию по загрузке файлов в выбранном месяце',
                    500,
                );
        }
    }

    async getFilesInfoIntervalDate(data) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...data,
                token,
            }),
        };
        const response = await fetch(`${this.domain}files/getFilesInfoIntervalDate`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.getFilesInfoIntervalDate(data);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить файлы для выбранного интервала', 500);
        }
    }

    // Работа с файлами документов заявок
    async uploadFilesToApplicantDocument(data) {
        const token = await this.userTokenService.getToken();
        data.append('token', token);
        const options = {
            method: 'POST',
            body: data,
        };
        const response = await fetch(`${this.domain}applicant_document/files/upload`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.uploadFilesToApplicantDocument(data);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось загрузить файлы', 500);
        }
    }

    async confirmFilesApplicantDocument(applicantId, documentId, fileIds) {
        const token = await this.userTokenService.getToken();
        const data = {
            applicant_id: applicantId,
            document_id: documentId,
            file_ids: fileIds,
        };
        const options = {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ...data,
                token,
            }),
        };
        const response = await fetch(`${this.domain}applicant_document/files/confirm`, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.confirmFilesApplicantDocument(applicantId, documentId, fileIds);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError(
                    'Не удалось подтвердить файлы.',
                    500,
                );
        }
    }

    async getApplicantDocumentFiles(documentId) {
        const token = await this.userTokenService.getToken();
        const options = {
            method: 'GET',
            headers: {
                Accept: 'application/json',
            },
        };
        const url = `${this.domain}applicant_document/files/get/${documentId}/?token=${token}`;
        const response = await fetch(url, options);
        if (response.ok) {
            return response.json();
        }
        switch (response.status) {
            case 401:
                await this.refreshToken();
                return this.getApplicantDocumentFiles(documentId);
            case 422:
                throw new AppError((await response.json()).messages.join('<br>'));
            default:
                throw new AppError('Не удалось получить список файлов.', 500);
        }
    }

    async downloadApplicantDocumentFile(id) {
        const link = document.createElement('a');
        const token = await this.userTokenService.getToken();
        const href = `${this.domain}applicant_document/files/download/${id}/?token=${token}`;
        link.setAttribute('href', href);
        link.setAttribute('download', 'download');
        link.click();
    }
}

export default FilemanagerService;
